import {Component, ViewChild, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapComponent, MapClickHandler, ClickDisplay} from '../map.component'
import {FourDService, Client} from '4d-mapper'
import {TranslateService} from '@ngx-translate/core';
import {BaseComponent} from '../../../commons/BaseComponent';
import {MapService} from '../../../commons/map.service';
import {AccessGroup, User, Role} from 'vasat';
import {map, mergeMap} from 'rxjs/operators';
import {Observable, forkJoin as observableForkJoin} from 'rxjs/index';
import {AppService} from '../../../commons/app.service';
import {Location} from '@angular/common';
import { EmbedCodeDialog } from '@src/app/commons/dialogs/embed-code-dialog';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'share-comp',
  templateUrl: './share.component.html',
  styles: ['div:nth-child(2) { background: rgba(0, 0, 0, 0.04);}']

})
export class ShareComponent extends BaseComponent implements OnInit, OnDestroy, MapClickHandler {


  shares: Client[]
  private groups: any;
  users: any[] = [];
  maxSharesReached: boolean = false;

  

  constructor(private route: ActivatedRoute, public router: Router,
              snackBar: MatSnackBar, dialog: MatDialog, private location: Location,
              public mapComp: MapComponent, public mapService: MapService, private trans: TranslateService, public fourD: FourDService, public service: AppService) {
    super(router, snackBar, dialog);

    mapService.onReady().subscribe(s => this.refresh())

    mapComp.activeDetails = this
    if (!mapComp.activeTab)
      mapComp.setTab('layers')

    mapComp.detailsNav.open()
 
    this.userRolesInit()
  }

  cancel() {
    this.navigateBack(this.location);
  }

  refresh() {
    this.users = [];
    this.fourD.activeTeam.accountGroups.queryObservable().pipe(
      map(res => this.groups = res.items),
      mergeMap(res => {
        let usersQueryObs: Observable<User[]>[] = []
        // Go through all AccessGroups and get the users obeservable and attach them to a forkJoin
        for (var i = 0; i < this.groups.length; i++) {
          let group: AccessGroup = this.groups[i]
          if(group.uid.indexOf('_admins') !== -1){
            usersQueryObs.push(group.users.queryObservable().pipe(map(i => group['cachedUsers'] = i.items)))
          }

        }
        return observableForkJoin(usersQueryObs)
      }),
      map(result => {
        this.users = []
        // Go through all the users list results and append them to the global users array.
        for (var i = 0; i < result.length; i++) {
          let ele = result[i]
          ele.forEach(u => {
            if (this.userIndex(this.users, u) == -1) this.users.push(u)
          })
        }
        this.mapService.currentProject.shareUsers.queryObservable().subscribe( shareUsers => {
          shareUsers.items.forEach(u => {
            if (this.userIndex(this.users, u) == -1) this.users.push(u)
          })
          this.users.sort((a, b) => a.name.localeCompare(b.name));
        })

      }),).subscribe();
  }

  userIndex(list: User[], user: User) {
    var index = -1
    for (var i = 0; i < list.length; i++) {
      let u = list[i]
      if (u.id == user.id) index = i
    }
    return index
  }

  invite() {
    this.trans.get('SIGNIN.EMAIL').subscribe(email => {
      var v = {placeholder: email}

      let camera = {};
      if (this.mapService.viewer) {
        camera = {
          position: {
            lat: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.latitude),
            lng: Cesium.Math.toDegrees(this.mapService.viewer.camera.positionCartographic.longitude),
            height: this.mapService.viewer.camera.positionCartographic.height
          },
          direction: {
            heading: Cesium.Math.toDegrees(this.mapService.viewer.camera.heading),
            pitch: Cesium.Math.toDegrees(this.mapService.viewer.camera.pitch),
            roll: Cesium.Math.toDegrees(this.mapService.viewer.camera.roll)
          }
        }
      }
      
      var inp = {
        permissions: [ { key:'inspect', value:true }, { key:'measure', value:true }, { key:'download', value:false }, { key:'see_disabled_layers', value:false }, { key:'see_all_scenes', value:false } ] 
      };
      this.maxSharesReached = false;
      this.openDialog('SHARES.NAME', null, 'SHARES.INVITE', 'GENERIC.CANCEL', inp).subscribe(dialog => {
        // ONLY add share if user has provided an email or name otherwise it will generate an empty entry on the backend
        if (dialog.name || dialog.email) {
          this.mapService.addShare(dialog, camera).subscribe(s => {
            //used when shared link is clicked
            this.mapService.currentProject['lastActiveScene'] = this.mapService.scene.id;
            this.mapService.currentProject.saveObservable().subscribe();
  
            this.refresh()
            this.trans.get('SHARES.INVITED', {email: s}).subscribe()
          }, e => {
            if (e.status === 4301) {
              this.maxSharesReached = true;
            }
          });
        }
      })
    })
  }

  rm(c: Client) {
    this.openDialog('SHARES.DELETE', 'SHARES.DELETE_TEXT', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
      if (s) {
        this.mapService.removeShare(c)
          .subscribe(s => {
            this.trans.get('SHARES.DEL', {email: s}).subscribe();
            this.maxSharesReached = false;
          }, e => this.openSnackBarError(e.message))
      }
    })

  }

  cp(c:Client){
        
      // get the value
      let val = this.getLink(c);
      
      const listener = function(ev) {
        ev.preventDefault();
        ev.clipboardData.setData('text/plain', val);
      };
      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);

      // assume success
      this.openSnackBarSuccess('GENERIC.COPIED')
  }

  embed(c:Client) {
    console.info(c);
    let dialogRef = this.dialog.open(EmbedCodeDialog, {
      width: '600px',
      height: '300px', 
      data: {
        url: this.getLink(c)
      }
    });

    return dialogRef.afterClosed();
  }

  getLink(c:Client): string {
    return 'https://' + location.hostname + '/auth/share/' + c.token + '/' + c.secret;
  }

  clickedMap(movement: any, rightClick: boolean, checkedPosition): ClickDisplay {
    // console.log ( 'share.comp :: clickedMap()');
    if (rightClick) {
      this.mapComp.detailsNav.close()
      this.router.navigate(['/app/projects/map', this.mapService.currentProject.id, 'layers'])
    }
    return ClickDisplay.None
  }
  
  /* Shaz quick n dirty version, Alex please transplant to a better place as needed */
     
  roleGroups:{
    uid:string
    name:string
    users:{
      name:string
      id:number
    }[]
  }[] = []

  userRolesInit(){
    this.mapService.onReady().subscribe(_ => 
     this.userRolesRefresh()
    )
  }
  userRolesRefresh(){
    this.fourD.V.get('/api/Project/' + this.mapService.currentProject.id + '.acl').subscribe(res => 
      this.roleGroups = res.payload
    )
  }
  addUserTo(uid:string,user:User){
    this.fourD.V.put('/api/Project/' + this.mapService.currentProject.id + '.acl/' + uid + '/' + user.id,{}).subscribe(_ => this.userRolesRefresh())
  }
  removeUserFrom(uid:string,user:User){
    this.openConfirmDelete(() => 
      this.fourD.V.delete('/api/Project/' + this.mapService.currentProject.id + '.acl/' + uid + '/' + user.id).subscribe(_ => this.userRolesRefresh())
      ,'Remove ' + user.name + ' from this role?')
  }

  currentSceneFilter(sharedClient:Client): boolean {
    return sharedClient["activeSceneId"] == this.mapService.scene.id
  }
}
